module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei4.svg";